/**
 * Parcels Receipt
 */

// React
import React, { useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../../redux/reducers';
import { getOrdersAction, getPostOrderWithIdAction } from '../../actions';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import Barcode from 'react-barcode';

// Selector
import { createStructuredSelector } from 'reselect';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';

// Helper
import { OrderTransportationType, translate } from '../../../../utils/helpers';

// Type
import { SelectorProps, Props } from './interfaces';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectOrdersList,
} from '../../selectors';
import { QRCode } from 'react-qr-svg';
import useQuery from '../../../../utils/hook/useQuery';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();
  const [request3PLLoading, setRequest3PLLoading] = useState(false as boolean);
  const [request3PLError, setRequest3PLError] = useState(false as boolean);
  const [transportationValue, setTransportationValue] = useState<
    OrderTransportationType
  >('');
  const [orderResults3PL, setOrderResults3PL] = useState([]);
  const orderId = props.location.search.split('?id=')[1].split(',');

  useEffect(() => {
    const { id } = props.match.params;
    // props.getOrderDispatch({});
    handleGetOrders3PL(orderId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getOrders3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.getOrder3PLs({
        payload,
      });
      setOrderResults3PL(response.data);
      console.log(response.data);
      callback && callback();
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };
  const handleGetOrders3PL = (orderId: []) => {
    getOrders3PL({
      'orderId.in': orderId,
      tplCode: transportationValue,
      size: 100,
      callback: () => {
        window.print();
      },
    });
  };

  return (
    <WrapperReceipt className={classes.root}>
      {orderResults3PL.map(orderResults => {
        return (
          <div className='page-container'>
            <div className="page">
              <div style={{ textAlign: 'center', fontFamily: 'monospace' }}>
                {orderResults.orderId ? orderResults.orderId : 'null'}
              </div>
              <div style={{ textAlign: 'center' }}>
                {orderResults.tplCode ? translate(orderResults.tplCode, 'TPL') : 'null'}
              </div>
              <div className=" wrapper ">
                {/*Section 1 */}
                <div className="flex">
                  <div style={{ width: '100%' }} className="flex flex-column">
                    <div className="flex flex-row" style={{ margin: '5px 0', justifyContent: 'center' }}>
                      <QRCode
                        style={{ width: '27%' }}
                        value={
                          orderResults.tplTrackingCode
                            ? orderResults.tplTrackingCode
                            : 'null'
                        }
                      />
                    </div>
                  </div>
                  <div className="flex-1" />
                </div>
              </div>
              <div style={{ textAlign: 'center', fontFamily: 'monospace' }}>
                {orderResults.tplTrackingCode ? orderResults.tplTrackingCode : 'null'}
              </div>
              <div className=" wrapper ">
                {/*Section 1 */}
                <div className="flex">
                  <div style={{ width: '100%' }} className="flex flex-column">
                    <div className="flex flex-row" style={{ margin: '5px 0', justifyContent: 'center' }}>
                      <Barcode
                        fontSize={12}
                        value={
                          orderResults.tplTrackingCode
                            ? orderResults.tplTrackingCode
                            : 'null'}
                        height={'30px'}
                        background="White"
                      />
                    </div>
                  </div>
                  <div className="flex-1" />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </WrapperReceipt>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getOrderDispatch: (payload: { id: number }) =>
      dispatch(getOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
